import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';

Snappy.Component.HospitalityEnquiryForm = class HospitalityEnquiryForm extends Snappy.BaseComponent {
    static get tagName(){
        return 'fa-hospitality-enquiry-form';
    }

      constructor(element) {
        super(element);

        $(".scrollTo").on('click',
            function (e) {
                e.preventDefault();
                var target = $(this).attr('href');
                $('html, body').animate({
                        scrollTop : ($(target).offset().top - 150)
                    },
                    800);

                var packageId = $(this).attr('name');
                $(".packageCheckbox").each(function(i, val) {
                    $(this).prop('checked', val.name.toLowerCase() == "package_{" + packageId + "}");
                });
            });
    }

    render() {
        this.setVars();
        this.addEventListeners();
    }

    setVars() {
        this.submited = false;
        this.$form = this.$element.find('.fa-hospitality-enquiry-form__form');
        this.$messageContainer = this.$element.find('.message-container');
        this.errorClass = 'fa-input-field--error';
        this.messageClass = 'fa-input-field__error-message';
        this.firstNameInput = document.getElementById("firstName-field");
        this.lastNameInput = document.getElementById('lastName-field');  
        this.telephoneInput = document.getElementById('telephone-field');
        this.postcodeInput = document.getElementById('postcode-field');  
        this.emailInput = document.getElementById('email-field-main');
        this.formTextInputs = document.querySelectorAll('.fa-hospitality-enquiry-form__form input[type=text]');
        this.formdropInputs = document.querySelectorAll('.fa-hospitality-enquiry-form__form select');
        this.memberCircleInput = document.querySelectorAll('.fa-hospitality-enquiry-form__checkboxArea input[type=checkbox]');
        this.ageInput = document.getElementById('gdprConsentField');
    }

      addEventListeners() {
        this.$form.on('submit', this.onFormSubmission.bind(this));
        this.firstNameInput.addEventListener('keypress', this.restrictNumber.bind(this));
        this.lastNameInput.addEventListener('keypress', this.restrictNumber.bind(this));
        this.telephoneInput.addEventListener('keypress', this.restrictAlphabet.bind(this));
        this.postcodeInput.addEventListener('keypress', this.restrictSpecialChar.bind(this));
        this.emailInput.addEventListener('keyup',this.emailValidation.bind(this));
        this.ageInput.addEventListener('change',this.checkboxError.bind(this));
        
        for (let i = 0; i < this.formTextInputs.length; i++) {          
            this.formTextInputs[i].addEventListener('keyup', this.removeError.bind(this));        
            
        }  

        for (let i = 0; i < this.formdropInputs.length; i++) {          
            this.formdropInputs[i].addEventListener('change', this.removeError.bind(this));        
            
        } 

        for (let i = 0; i < this.memberCircleInput.length; i++) {          
            this.memberCircleInput[i].addEventListener('change', this.radioCheckError.bind(this));        
            
        } 
    }

    removeError(event) {        
        if(this.submited){
            if(event.target.parentElement.getElementsByClassName('fa-input-field__error-message')[0].innerHTML != ''){
                if(event.target.value.length > 0 || event.target.value != '') {     
                    if (event.target.classList.contains('error')) {
                    event.target.classList.remove('error');
                    event.target.parentElement.getElementsByClassName('fa-input-field__error-message')[0].style.display = 'none';
                }
            } else {
                event.target.classList.add('error');
                event.target.parentElement.getElementsByClassName('fa-input-field__error-message')[0].style.display = 'block';
            }
        } else {
            // console.log('falsr');
        }
    } else {
        // console.log('falsr');
    }
}
checkboxError(event) {
    if(this.submited) {
        if(event.target.parentElement.getElementsByClassName('fa-input-field__error-message')[0].innerHTML != '') {
            if(event.target.checked) {                   
                event.target.classList.remove('error');
                event.target.parentElement.getElementsByClassName('fa-input-field__error-message')[0].style.display = 'none';            
            } else {                    
                event.target.classList.add('error');
                event.target.parentElement.getElementsByClassName('fa-input-field__error-message')[0].style.display = 'block';
            }   
        } else{
           // console.log('false');
        }
    } else {
        // console.log('false');
    }
}
radioCheckError(event){
    if(this.submited) {          
        let ele = $('.group-message-container').find(".fa-input-field__error-message");
        let checkLength = document.querySelectorAll('.fa-hospitality-enquiry-form__checkboxArea__content input:checked').length;
        if(checkLength != 0){
            ele.css('display', 'none');
        } else {
            ele.css('display', 'block');
        }          
    } else {
        // console.log('falsr');
    }
}
emailValidation(evt) {
    if(this.submited){
        const theEvent = evt || window.event;
        const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (regex.test(theEvent.target.value)) {
            if (theEvent.target.classList.contains('error')) {
                theEvent.target.classList.remove('error');
                theEvent.target.parentElement.getElementsByClassName('fa-input-field__error-message')[0].style.display = 'none';
            } else {
                // console.log('falsr');
            }
        } else {
            theEvent.target.classList.add('error');
            theEvent.target.parentElement.getElementsByClassName('fa-input-field__error-message')[0].style.display = 'block';
        }
    }
}
    restrictNumber(evt) {
        const theEvent = evt || window.event;
         let keyCode = theEvent.keyCode || theEvent.which;
         let key = String.fromCharCode(keyCode);         
         const regex = /[0-9]|\./;
         let checkSpace = this.checkFirstSpace(evt, theEvent.target.value);
         if(checkSpace) {
            if(keyCode == 46) {
                
                if (!regex.test(key)) {                    
                    theEvent.returnValue = false;
                if (theEvent.preventDefault) {
                    
                    theEvent.preventDefault();
                    } else {
                       // console.log('true');
                    }
                } else {
                    //console.log('no regex');
                }
            } else {
                if (regex.test(key)) {
                    theEvent.returnValue = false;
                if (theEvent.preventDefault) {
                    
                    theEvent.preventDefault();
                    } else {
                       // console.log('true');
                    }
                } else {
                    //console.log('no regex');
                }
            }
            
        } else {
            //console.log('entered space at first');
        }
        
    }
    
    restrictAlphabet(evt) {
        const theEvent = evt || window.event;
        let keyCode = theEvent.keyCode || theEvent.which;
        let key = String.fromCharCode(keyCode);  
                
         const regex = /[a-zA-Z]|\./;   
         let checkSpace = this.checkFirstSpace(evt, theEvent.target.value);
         if(checkSpace) {             
            if(keyCode == 46) {
                
                if (!regex.test(key)) {                    
                    theEvent.returnValue = false;
                if (theEvent.preventDefault) {
                    
                    theEvent.preventDefault();
                    } else {
                       // console.log('true');
                    }
                } else {
                    //console.log('no regex');
                }
            } else {
                if (regex.test(key)) {
                    theEvent.returnValue = false;
                if (theEvent.preventDefault) {
                    
                    theEvent.preventDefault();
                    } else {
                       // console.log('true');
                    }
                } else {
                    //console.log('no regex');
                }
            }
            
        } else {
           // console.log('entered space at first');
        }
    
    }

    restrictSpecialChar(evt){
        const theEvent = evt || window.event;
        let key = theEvent.keyCode || theEvent.which;
        let keyCode = theEvent.keyCode || theEvent.which;         
        key = String.fromCharCode(keyCode);        
        const regex = /[a-zA-Z0-9 ]|\./;   
        let checkSpace = this.checkFirstSpace(evt, theEvent.target.value);
        if(checkSpace) {           
            if(keyCode == 46) {
                if (regex.test(key)) {
                    theEvent.returnValue = false;
                    if (theEvent.preventDefault) {
                    theEvent.preventDefault();
                    } else{
                       // console.log('true');
                    }
                    } else {
                      //  console.log('no regex');
                    }  
            } else {
            if (!regex.test(key)) {
            theEvent.returnValue = false;
            if (theEvent.preventDefault) {
            theEvent.preventDefault();
            } else{
               // console.log('true');
            }
            } else {
              //  console.log('no regex');
            } 
        }
        }  else {
           // console.log('entered space at first');
        }   
    }

    checkFirstSpace(evt) {
        const theEvent = evt || window.event;
        let key = theEvent.keyCode || theEvent.which;       
            
        if(key == 32 && theEvent.target.value.length <=0)
        {
            theEvent.preventDefault();
            return false;
        }
        else{    
            return true;
            }
    }    
    
    restrictFirstSpl(evt){
        const theEvent = evt || window.event;
        let key = theEvent.keyCode || theEvent.which;
        key = String.fromCharCode(key);
        const regex = /[a-zA-Z0-9]|\./;
        if(theEvent.target.value.length <= 0){             
            if (!regex.test(key)) {
            theEvent.returnValue = false;
            if (theEvent.preventDefault) {
                theEvent.preventDefault();
                } else{
                    //console.log('true');
                }
            } else {
                //console.log('no regex');
            }
        } else {
            // console.log('true reg');
        }
    }

    onFormSubmission(event) {

        event.preventDefault();
        this.submited = true;

  var offersUpdatesFieldVal = false;
        if ($('#offersUpdatesField') && $('#offersUpdatesField:checked').length !== 0) {
            offersUpdatesFieldVal = true;
        }
        var gdprConsentField = false;
        if ($('#gdprConsentField') && $('#gdprConsentField:checked').length !== 0) {
            gdprConsentField = true;
        }

        var nflFieldVal = false;
        if ($('#nflField') && $('#nflField:checked').length !== 0) {
            nflFieldVal = true;
        }
 let ele1 = $('.group-message-container').find(".fa-input-field__error-message");
        if ($('.packageCheckbox')  && $('.packageCheckbox:checked').length !== 0) {
            ele1.css('display', 'none');
        } else {
            ele1.css('display', 'block');
        }
        var formData = {
            Title: { FieldName: "titleField", FieldValue: $("#title-field :selected").val() },
            FirstName: { FieldName: "firstNameField", FieldValue: $("#firstName-field").val() },
            LastName: { FieldName: "lastNameField", FieldValue: $("#lastName-field").val() },
            EmailAddress: { FieldName: "emailField", FieldValue: $("#email-field-main").val() },
            PhoneNumber: { FieldName: "telephoneField", FieldValue: $("#telephone-field").val() },
            Enquiry: { FieldName: "enquiryField", FieldValue: $("#enquiry-field").val() },
            AgeRange: { FieldName: "ageField", FieldValue: $("#age-field :selected").val() },
            Club: { FieldName: "teamField", FieldValue: $("#team-field :selected").val() },
            Postcode: { FieldName: "postcodeField", FieldValue: $("#postcode-field").val() },
            EventsInterest: { FieldName: "eventsInterest", FieldValue: $("#hidEventName").val() },
            PackageInterest: { FieldName: "packageInterest", FieldValue: $("input.packageCheckbox:checked").val() },
            ReceiveOffers: offersUpdatesFieldVal,
            NFLConsent: nflFieldVal,
            GDPRConsent: gdprConsentField
        };

        const requiredFieldse = {
            title: 'titleField',
            postcodeField: 'postcodeField',
            firstNameField: 'firstNameField',
            lastNameField: 'lastNameField',
            ageField: 'ageField',
            emailField: 'emailField',
            telephoneField: 'telephoneField',
            packageCheckbox: 'packageCheckbox',
            gdprConsentField: "gdprConsentField"
            
        }

        let count = 0;
        let keysLength = Object.keys(requiredFieldse).length;
        // add errors to all required fields
        Object.keys(requiredFieldse).forEach(function (key) {
            let fieldName = document.getElementsByName(`${requiredFieldse[key]}`)

            for (var i = 0; i < fieldName.length; i++) {
                let str = '';
                if(fieldName[i].parentElement.getElementsByClassName('fa-dropdown__label') && fieldName[i].parentElement.getElementsByClassName('fa-dropdown__label').length > 0) {
                    str =  fieldName[i].parentElement.getElementsByClassName('fa-dropdown__label')[0].innerHTML;
                    str = str.toString().replace(/[^a-zA-Z ]/g, "");
                }
                if(fieldName[i].parentElement.getElementsByClassName('fa-input-field__label') && fieldName[i].parentElement.getElementsByClassName('fa-input-field__label').length > 0) {
                    str =  fieldName[i].parentElement.getElementsByClassName('fa-input-field__label')[0].innerHTML;
                    str = str.toString().replace(/[^a-zA-Z ]/g, "");
                }
                 
                if((requiredFieldse[key] === 'gdprConsentField')) {
                    let consentEle2 = document.getElementsByClassName("margin-top-3")[0];
                    let policyEle2 = document.getElementsByClassName("policy-para")[0];
                    console.log("in if :",consentEle2);
                    if(fieldName[i].checked === false) {
                        count++;
                        if(requiredFieldse[key] == 'gdprConsentField') {
                            if(consentEle2) {
                                if(screen.width <= 767) {
                                    consentEle2.style.marginTop = '13%';
                                } else if(screen.width > 767 && screen.width <= 992) {
                                    consentEle2.style.marginTop = '5%';
                                }else {
                                    consentEle2.style.marginTop = '3%';
                                }
                            }
                            fieldName[i].parentElement.getElementsByClassName('fa-input-field__error-message')[0].textContent = `Please confirm your age`;
                        } 
                        
                       
                        fieldName[i].parentElement.getElementsByClassName('fa-input-field__error-message')[0].style.display = 'block';
                    } else {
                        if(fieldName[i].checked && requiredFieldse[key] == 'gdprConsentField') {
                            if(consentEle2) {
                                if(screen.width <= 767) {
                                    consentEle2.style.marginTop = '7%';
                                } else if(screen.width > 767 && screen.width <= 992) {
                                    consentEle2.style.marginTop = '2%';
                                }else {
                                    consentEle2.style.marginTop = '5px';
                                }
                            }
                        }
                       
                        fieldName[i].classList.remove('error');
                         fieldName[i].parentElement.getElementsByClassName('fa-input-field__error-message')[0].textContent = '';
                         fieldName[i].parentElement.getElementsByClassName('fa-input-field__error-message')[0].style.display = 'none';
     
                    }
                } else {
                    if (fieldName[i].value === '' ) {
                        count++;
                        fieldName[i].classList.add('error');                       
                        fieldName[i].parentElement.getElementsByClassName('fa-input-field__error-message')[0].textContent = `Please enter your ${str.toLocaleLowerCase()}`;
                        fieldName[i].parentElement.getElementsByClassName('fa-input-field__error-message')[0].style.display = 'block';
                    } else {
                        fieldName[i].classList.remove('error');
                         fieldName[i].parentElement.getElementsByClassName('fa-input-field__error-message')[0].textContent = '';
                         fieldName[i].parentElement.getElementsByClassName('fa-input-field__error-message')[0].style.display = 'none';
     
                    }
                }
                
            }
        });
        if (count == 0) {

                    console.log("formData : ",formData);
                    let emailTemp = false;
                    let emailEle = $('.cw-new-theme #email-field-main')
                    if($('.cw-new-theme #email-field-main') && $('.cw-new-theme #email-field-main').val()) {
                        const expr = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                        emailTemp =   expr.test($('.cw-new-theme #email-field-main').val());
                    }
                    if(emailTemp) {
                        emailEle.removeClass('error');  
                        emailEle.parent().find(".fa-input-field__error-message").text("");           
                        emailEle.parent().find(".fa-input-field__error-message").css('display','none');                    
                              $.ajax({
                            beforeSend: function () {
                                $('.loading-message-wrapper').removeClass('hide').addClass('show');
                              
                            },
                            url: this.formAction = this.$form.attr('action'),
                            method: this.formMethod = this.$form.attr('method'),
                            data: this.formData = formData
                        })
                        
                            .always(
                                this.handleValidationResponse.bind(this)
                            );
                    } else {
                        $('html, body').animate({
                            scrollTop: ($('.cw-new-theme #email-field-main').offset().top - 100)
                        },
                        800);
                        emailEle.addClass('error');  
                        emailEle.parent().find(".fa-input-field__error-message").text("Please enter your email");           
                        emailEle.parent().find(".fa-input-field__error-message").css('display','block');           
                        $(".loading-message-wrapper").delay(500).queue(function(next) {
                            $(this).removeClass('show').addClass('hide');
                            next();
                        });
                    }
                } else {
                    this.scrollToFromTitle();
                }
        

    }

    scrollToFromTitle() {
        $('html, body').animate({
            scrollTop: ($('.form-title').offset().top)
        },
        800);
        $(".loading-message-wrapper").delay(500).queue(function(next) {
            $(this).removeClass('show').addClass('hide');
            next();
        });
    }

    handleValidationResponse(response) {
        console.log("errors",response);
        // this.hideAllValidationErrors();
        $(".loading-message-wrapper").delay(500).queue(function(next) {
            $(this).removeClass('show').addClass('hide');
            next();
        });
        let newele2e = $(".error-message--backend");
        if (response.success) {
            if(newele2e) {
                newele2e.css("display", "none");
                console.log("Success redirect!");
            }
            this.handleSuccess(response);
        } else if(response && response.success == false){
            if(newele2e) {
                newele2e.css("display", "block");
                console.log("Failed to redirect!");
                if(response.fields && response.fields.length > 0) {
                    newele2e.text(response.fields[0].Reason)
                }
            }
        }
    }

    hideAllValidationErrors() {
        $(".fa-input-field--error").each(function() {
            $(this).removeClass("fa-input-field--error");
        });
    }

    showValidationError(field) {
        const $element = this.$form.find(`[name=${field.FieldName}]`);
        $element
            .addClass(this.errorClass)
            .parent()
            .addClass(this.errorClass)
            .find(`.${this.messageClass}`).text(field.Reason);
    }

    removeValidationError(field) {
        const $element = this.$form.find(`[name=${field.element}]`);

        $element
            .removeClass(this.errorClass)
            .parent()
            .removeClass(this.errorClass)
            .find(`.${this.messageClass}`).text('');
    }

    handleSuccess(response) {
        var domain = document.location.origin;
        console.log("Done");
        dataLayer.push({ 'crmUserId': response.CrmUserId });
        dataLayer.push({ 'thankYouURL': window.location.href + '/thankyou' });
        window.location.replace(domain + "/experiences/events/confirmation");
       
        
    }

   

    resetForm() {
        this.$form.find('input, select, textarea').each((i, element) => {
            element.value = '';
        });
    }
}

$(function() {
     var CWHospitalityEnquiryForm = new Snappy.Component.HospitalityEnquiryForm();

    $('.packageCheckbox').change(function() {
        $('.packageCheckbox').not(this).prop('checked', false);
    });
  let consentEle2 = document.getElementsByClassName("margin-top-3")[0];
    let policyEle2 = document.getElementsByClassName("policy-para")[0];
    if(consentEle2) {
        if(screen.width <= 767) {
            consentEle2.style.marginTop = '7%';
        } else if(screen.width > 767 && screen.width <= 992) {
            consentEle2.style.marginTop = '2%';
        }else {
            consentEle2.style.marginTop = '5px';
        }
    }
    if(policyEle2) {
        if(screen.width <= 767) {
            policyEle2.style.marginTop = '5%';
            policyEle2.style.marginBottom = '4%';
        }else if(screen.width > 767 && screen.width <= 992) {
            policyEle2.style.marginTop = '3%';
            policyEle2.style.marginBottom = '4%';
        } else {
            policyEle2.style.marginTop = '5px';
        }
    }
    //Event Dropdown
    var defaultDescription = $('ul.fa-dropdown-content li.description-default');
    var eventDescription = $('ul.fa-dropdown-content li.description');

    $(eventDescription).hide();
    $(defaultDescription).show();

    $('.fa-dropdown select#event-title').change(function() {
        $(defaultDescription).hide();
        $(eventDescription).hide();
        $('#' + this.value).show();

        if ($(this).val() == '0') {
            $(defaultDescription).show();
        }
    });
});



// WEBPACK FOOTER //
// ./components/cw-enquiryform/scripts/hospitalityenquiryform.js